<template>
    <div>
        <input-label v-if="label" :for_element="name" :label_class="label_class"> {{ $t(label) }}</input-label>

        <textarea :type="type"
            class="field"
            :class="[
                input_class ? input_class : 'w-full',
                { 'read_only': read_only }
            ]"
            :rows="rows || 5"
            :name="name"
            :placeholder="$t(placeholder)"
            @input="$emit('input', $event.target.value)"
            v-bind="$attrs"
            ref="input"
            :readonly="read_only"
            :disabled="read_only"
        >{{ value }}</textarea>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        type: { default: 'text' },
        label: {},
        name: {},
        value: {},
        placeholder: {},
        rows: {},
        enter: { default: false },
        input_class: { default: null },
        label_class: { default: null },
        read_only: { default: false },
    },

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },
}
</script>

<style scoped>
    .read_only {
        background-color: #f7f7f7 !important;
        border-color: #f7f7f7 !important;
        color: #262626 !important;
    }

    .accordion .read_only {
        background-color: #fcfcfc !important;
    }

    .read_only::placeholder {
        color: transparent !important;
    }
</style>
